import { getWindowLocation } from './getWindowLocation';
import { tagetedProductPageUrls, CMS_HUB_URL, SALES_URL, FRENCH_DOMAIN_PATTERN } from '../constants/targetedProductPageUrls';
export const isFrenchSalesPage = (hostname, pathname) => {
  return FRENCH_DOMAIN_PATTERN.test(hostname) && pathname.startsWith(SALES_URL);
};
export const isOneOfTargetedProductPages = () => {
  const url = new URL(getWindowLocation().paramValue('url'));
  return tagetedProductPageUrls.includes(url.pathname) || url.pathname.startsWith(CMS_HUB_URL) || isFrenchSalesPage(url.hostname, url.pathname);
};